import {useCallback, useEffect, useState} from "react";
import {changehue, checkContrast} from "../../../utils/colorcontrast";
import ColorPicker from "../../../components/admin/utilities/ColorPicker";
import {observer} from "mobx-react";
import {useStores} from "../../../stores/useStores";

export const ThemeColorInput = observer((props: {
    name: string,
    value: string,
    currentThemeId: number,
    onChange: (value: string) => void,
}) => {
    const {organizationStore, styleStore} = useStores();
    const {name, currentThemeId} = props;

    useEffect(() => {
        // these are the two contrasts that depend on each other, so we need to setup a listener for its partner
        if (name === "primaryNavBackground" || name === "primaryNavFontColor") {
            setPassesContrast(doColorComparison());
        }
    }, [
        organizationStore.organization.json_data.settings.appearance.themes[currentThemeId].primaryNavBackground,
        organizationStore.organization.json_data.settings.appearance.themes[currentThemeId].primaryNavFontColor,
    ])

    const doColorComparison = useCallback(() => {
        const cssVars = styleStore.cssVars;
        let background, foreground;
        switch (props.name) {
            case "primaryNavBackground":
                background = cssVars.primaryNavBackground;
                foreground = props.currentThemeId === 1 ? cssVars.primaryNavBackgroundTextColor : cssVars.primaryNavFontColor;
                break;
            case "secondaryNavBackground":
                background = cssVars.secondaryNavBackground;
                foreground = cssVars.secondaryNavBackgroundTextColor;
                break;
            case "blocks":
                background = cssVars.blocks;
                foreground = cssVars.blocksTextColor;
                break;
            case "elements":
                background = cssVars["sb-accent-9"];
                foreground = cssVars["sb-contrast"];
                break;
            case "primaryNavFontColor":
                background = cssVars.primaryNavBackground;
                foreground = cssVars.primaryNavFontColor;
        }

        let themeName;
        switch (props.currentThemeId) {
            case 1:
                themeName = "simple_and_clean";
                break;
            case 2:
                themeName = "floating_blocks";
                break;
        }

        const previousTheme = cssVars.theme;
        if (previousTheme !== themeName && props.currentThemeId > 0) {
            styleStore.setCssVars({...cssVars, theme: themeName});
        }

        return checkContrast(foreground, background);
    }, [props.value]);

    const [passesContrast, setPassesContrast] = useState<boolean>(doColorComparison());

    function handleLighten(e) {
        e.preventDefault();
        const newColor = changehue(props.value, 'lighten');
        if (newColor) {
            handleChange("#" + newColor);
        }
    }

    function handleDarken(e) {
        e.preventDefault();
        const newColor = changehue(props.value, 'darken');
        if (newColor) {
            handleChange("#" + newColor);
        }
    }

    function handleChange(color) {
        props.onChange(color);

        if (organizationStore.organization.json_data) {
            organizationStore.updateThemeSettings({
                [props.name]: color,
            }, props.currentThemeId);
        }

        setPassesContrast(doColorComparison());
    }

    return <>
        <div className={"col-lg-3"}>
            <ColorPicker color={props.value} picker={"ChromePicker"} handleColorChange={handleChange}/>
        </div>
        <div className="col-lg-4 col-xs-12 col-sm-12 sb-contrast-checker-result">
            <span>Compliance: </span>
            <span className={passesContrast ? "pass" : "fail"}>{passesContrast ? "Passed" : "Failed"}</span>
            {passesContrast || <span className={"help-block"}>Lighten or darken to fix.</span>}
            <div>
                <button onClick={handleLighten} className="fglighten">lighten<span
                    className="hidden"> foreground</span></button>
                |
                <button onClick={handleDarken} className="fgdarken">darken<span
                    className="hidden"> foreground</span></button>
            </div>
        </div>
    </>
})
